import React, { Component } from 'react';
import { IconWoman, IconMan } from '@tabler/icons';
import { withLocalize } from "react-localize-redux";
import { Grid } from '@mantine/core';
import {Chart, ArcElement, Tooltip, Legend} from 'chart.js'
import { Bar } from 'react-chartjs-2';
import { BarElement } from 'chart.js';
import {CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title} from 'chart.js'
Chart.register(ArcElement, Tooltip, Legend, CategoryScale,
    BarElement,
    LinearScale,
    PointElement,
    LineElement,
  Title
);

const drawValuesPlugin = (props) => ({
  id: 'drawValues',
  afterDatasetsDraw: (chart) => {
    const ctx = chart.ctx;
    chart.data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      meta.data.forEach((bar, index) => {
        const value = dataset.data[index];
        let AbsoluteValue = Math.abs(value);
        if (AbsoluteValue === 0) { AbsoluteValue = "" }
        let offSet = 0
        ctx.fillStyle = 'black';
        if ( dataset.label === props.translate('content.information-consultant.gender.female')  ) { 
          offSet = -23
        }
        if ( dataset.label === props.translate('content.information-consultant.gender.male')  ) { 
          offSet = -3
        }
        ctx.fillText( "  " + AbsoluteValue, bar.x + offSet, bar.y + 1);
      });
    });
  }
});

class BarGender extends Component { 

  render() {
    const options = {
      indexAxis: 'y',
      elements: {
        bar: {
          borderWidth: 2,
        },
      },
      responsive: true,
      plugins: {
        drawValues: true,
        legend: {
          position: 'bottom',
        },
        title: {
          display: false,
          text: 'if need, title go here',
        },
        tooltip: {
          callbacks: { // le callback ici sert à changer l'affichage des données pour cacher le "-" des valeurs négatifs
            label: function(context) {
              let label = context.dataset.label || '';
              if (label) {
                label += ': ';
              }
              label += Math.abs(context.raw); 
              return label;
            }
          }
        }
      },
      scales: {
        x: {
          display: false,
          beginAtZero: true,
          stacked: true,
          //min: -Math.max(...this.props.data[1][0], ...this.props.data[1][1]), // if needed to center graph
          //max: Math.max(...this.props.data[1][0], ...this.props.data[1][1]),  // if needed to center graph
          ticks: { // ticks sert à changer l'affichage des données pour cacher le "-" des valeurs négatifs
            callback: function(value) {
              return Math.abs(value); 
            }
          }
        },
        y: {
          stacked: true,
        },
      },
    };
  
    const labels = this.props.data[0];

    const data = {
      labels,
      datasets: [
        {
          label: this.props.translate('content.information-consultant.gender.female'),
          data: this.props.data[1][1],
          borderColor: 'rgb(75, 192, 192)',
          backgroundColor: 'rgba(75, 192, 192, 0.5)',
        },
        {
          label: this.props.translate('content.information-consultant.gender.male'),
          data: this.props.data[1][0],
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
        }
      ],
    };
  
    return (
      <div>
        <Grid columns={14} >
          <Grid.Col offset={3} span={3}>
            <IconWoman style={{ width: '85%', height: '85%' }} stroke={1.5} color="green" />
          </Grid.Col>
          <Grid.Col span={3}>
            <IconMan style={{ width: '85%', height: '85%' }} stroke={1.5} color="red" />
          </Grid.Col>
        </Grid>
        <Bar options={options} data={data} plugins={[drawValuesPlugin(this.props)]} />
      </div>
    );
  }

}
export default withLocalize(BarGender)